var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"close",on:{"click":_vm.handleClose}},[_c('SvgIcon',{attrs:{"icon-class":"close","width":"24","height":"24"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }